import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
  selector: '[inTemplate]'
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class InsparkTemplate {

  @Input() type: string;

  @Input('inTemplate') name: string;

  constructor(public template: TemplateRef<any>) {
  }

  getType(): string {
    return this.name;
  }
}
